export default "__VITE_ASSET__f9e32d05__"